import queryString from "query-string";

export function getQueryValue(param: string) {
  return getQueryValueFromString(window.location.search, param);
}

export function getQueryValueFromString(search: string, param: string) {
  return queryString.parse(search)[param];
}
